// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y1-1";
export var printerIcon = "_y1-0";